// ATTENTION UI DESIGNERS
// ---------------------
// This is an Echart definition of a chart. You can explore it in the Echarts PLAYGROUND (https://echarts.apache.org/examples/en/editor.html)
// PLAYGROUND: https://echarts.apache.org/examples/en/editor.html
// Echarts list of examples: https://echarts.apache.org/examples/en/index.html#chart-type-pie
// An example Echart: https://echarts.apache.org/examples/en/editor.html?c=pie-doughnut
// PLAYGROUND: https://echarts.apache.org/examples/en/editor.html
// DOCUMENTATION: https://echarts.apache.org/en/option.html
// NOTE: Always verify that this file works in both Connect and the PLAYGROUND
// NOTE: Developer, when possible, update the `option = options({ ... put example values here if possible ... })` to reflect example data.
// This entire file can be cut and pasted into the PLAYGROUND IF you change the commenting on the following 2 lines
export { options }; // In the PLAYGROUND, comment out this line. In this file, keep it uncommented.
// option = options({ compliant: 10, conditional: 5, subText: "TESTING 123" }); // In the PLAYGROUND, uncomment this line and add/change values. In this file, keep it commented.

function options(jsonValues) {
  // VARIABLES BEGIN: all variables pulled in from the jsonValues should be listed here
  const compliant = jsonValues.compliant || 0;
  const conditional = jsonValues.conditional || 0;
  const noncompliant = jsonValues.noncompliant || 0;
  const pending = jsonValues.pending || 0;
  const compliantText = jsonValues.compliantText || "";
  const conditionalText = jsonValues.conditionalText || "";
  const noncompliantText = jsonValues.noncompliantText || "";
  const pendingText = jsonValues.pendingText || "";
  const nameText = jsonValues.nameText || "";
  const subText = jsonValues.subText || "";
  const sum = compliant + conditional + noncompliant;
  // VARIABLES END

  // SET THE DATA BEGIN
  const data = [];
  pushMaybe(data, "green", compliant, compliantText);
  pushMaybe(data, "orange", conditional, conditionalText);
  pushMaybe(data, "red", noncompliant, noncompliantText);
  pushMaybe(data, "gray", pending, pendingText);
  // SET THE DATA END

  return {
    tooltip: {
      trigger: "item",
    },
    title: {
      text: sum.toString(),
      subtext: subText,
      itemGap: 0,
      left: "center",
      top: "center",
      textStyle: {
        fontSize: "2rem",
      },
      subtextStyle: {
        fontSize: "0.85rem",
        verticalAlign: "center",
      },
    },
    series: [
      {
        name: nameText,
        type: "pie",
        startAngle: 0,
        data,
        radius: ["60%", "75%"],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: "center",
        },
        emphasis: {
          label: {
            show: true,
            fontSize: "1rem",
            fontWeight: "bold",
          },
        },
        labelLine: {
          show: false,
        },
      },
    ],
  };
}

function pushMaybe(list, color, value, name) {
  if (value) list.push({ value, name, itemStyle: { color } });
}
